export default __webpack_public_path__ + "static/media/g30272.490c7004.svg";